'use client'

import React from 'react'

import { useHits } from 'react-instantsearch'

import { Col, Row, SpacerBase } from '../../../atoms/GridSystem'

import AlgoliaSearchHit from '../AlgoliaHit/AlgoliaHit.component'

const AlgoliaHits = (props) => {
  const { hits, sendEvent } = useHits(props)

  return (hits && hits.length > 0) ? (
    <Row>
      {hits.map((hit) => (
        <Col key={hit.objectID} xs={12} md={6} lg={4} $direction="column">
          <AlgoliaSearchHit
            hit={hit}
            entity={props.entity}
            // onClick={() => sendEvent('click', hit, 'Hit Clicked')}
            // onAuxClick={() => sendEvent('click', hit, 'Hit Clicked')}
          />
          <SpacerBase xs={5} />
        </Col>
      ))}
    </Row>
  ) : null
}

export default AlgoliaHits
